import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { Breadcrumb } from '../../models/breadcrumb.model';
import { AuthService } from '../../services/auth.service';
import { LoggingMessageService } from '../../services/logging-message.service';
import { BreadcrumbComponent } from '../breadcrumb/breadcrumb.component';
import { MessageModule } from 'primeng/message';
import { environment } from 'src/environments/environment';

@Component({
  standalone: true,
  selector: 'app-shared-pg-notice',
  templateUrl: './pg-notice.component.html',
  styleUrls: ['./pg-notice.component.scss'],
  imports: [
    CommonModule,
    BreadcrumbComponent,
    MessageModule
  ]
})

export class PgNoticeComponent implements OnInit, OnDestroy {
  @Input() breadcrumbs: Breadcrumb[];
  @Input() menuLoading: boolean;
  @Input() hideLogout: boolean = false;
  @Output() logoutClicked: EventEmitter<any> = new EventEmitter();
  private $subscriptions: Subscription = new Subscription();
  public showMessages: boolean;
  private hasLoggedIn = false;
  public enableBreadcrumbSwitcher: boolean;

  constructor(private authService: AuthService,
              private logger: LoggingMessageService) {
              this.enableBreadcrumbSwitcher = environment.EnableBreadcrumbSwitcher;
  }

  ngOnInit(): void {}

  public isUserLoggedIn() {
    const loggedin = this.authService.isUserLoggedIn();
    if (loggedin === true) {
      this.hasLoggedIn = true;
    }
    if (!loggedin && this.hasLoggedIn) {
      this.hasLoggedIn = false;
      this.logoutUser();
    }

    return loggedin;
  }

  logoutUser() {
    this.logger.warn('pg-notice.component.ts', 'logoutUser', 0, '', 'Logout user event', '');
    this.logoutClicked.emit();
  }

  unsubscribe() {
    if (this.$subscriptions) {
      this.$subscriptions.unsubscribe();
    }
  }

  ngOnDestroy(): void {
    this.unsubscribe();
    // this.notificationService.disconnect();
  }
}
